export default __webpack_public_path__ + "static/media/useful_links_dox.431b190d.png";